import Polyline from '@mapbox/polyline';
import { IEstimateType } from '../types';
import { onValue } from "firebase/database";
import { firebase } from '../config/firebase.client';
import { FareCalculator } from '../other/FareCalculator';
import { CLEAR_ESTIMATE, FETCH_ESTIMATE, FETCH_ESTIMATE_SUCCESS, FETCH_ESTIMATE_FAILED } from "../store/types";

export const getEstimate = (estimateData: IEstimateType) => async (dispatch: any) => {
  const {
    settingsRef
  } = firebase;

  dispatch({
    type: FETCH_ESTIMATE,
    payload: estimateData,
  });


  let res = estimateData.routeDetails;

  if (res) {
    let points = Polyline.decode(res.polylinePoints);

    let waypoints = points.map((point) => {
      return {
        latitude: point[0],
        longitude: point[1]
      }
    });

    onValue(settingsRef, settingdata => {
      let settings = settingdata.val();
      let distance = settings.convert_to_mile ? (res.distance_in_km / 1.609344) : res.distance_in_km;

      const FareCalculatorValues = FareCalculator(distance, res.time_in_secs, estimateData.carDetails, estimateData.instructionData, settings.decimal);
      let { totalCost, grandTotal, convenience_fees } = FareCalculatorValues;

      dispatch({
        type: FETCH_ESTIMATE_SUCCESS,
        payload: {
          waypoints: waypoints,
          drop: estimateData.drop,
          pickup: estimateData.pickup,
          estimateTime: res.time_in_secs,
          carDetails: estimateData.carDetails,
          routeDetails: estimateData.routeDetails,
          instructionData: estimateData.instructionData,
          estimateDistance: parseFloat(String(distance)).toFixed(settings.decimal),
          fareCost: totalCost ? parseFloat(String(totalCost)).toFixed(settings.decimal) : 0,
          estimateFare: grandTotal ? parseFloat(String(grandTotal)).toFixed(settings.decimal) : 0,
          convenience_fees: convenience_fees ? parseFloat(String(convenience_fees)).toFixed(settings.decimal) : 0,
        },
      });
    }, { onlyOnce: true });
  } else {
    dispatch({
      type: FETCH_ESTIMATE_FAILED,
      payload: "No Route Found",
    });
  }

}

export const clearEstimate = () => (dispatch: any) => {
  dispatch({
    type: CLEAR_ESTIMATE,
    payload: null,
  });
}